import React from 'react'

const FileArrowDown = props => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.45313 4.05333L5.45312 8.20667V11.9467C5.45312 12.5867 6.22646 12.9067 6.67979 12.4533L10.1331 9C10.6865 8.44667 10.6865 7.54667 10.1331 6.99333L8.81979 5.68L6.67979 3.54C6.22646 3.09333 5.45313 3.41333 5.45313 4.05333Z'
        fill='#B64FCD'
      />
    </svg>
  )
}

export default FileArrowDown
